import React from "react";
import PropTypes from "prop-types";
import Badge from "../../../common/Badge";

const getProjectStatusColor = (status) => {
  if (status === "In Process") {
    return "#7AE0FF";
  }
  if (status === "Completed") {
    return "#2BC26A";
  }
  if (status === "Cancelled") {
    return "#FBA5A5";
  }
  if (status === "On Hold") {
    return "#7D6B91";
  }
  if (status === "Ready To Close") {
    return "#f8a167";
  }
  return "#CCCCCC";
};

const ProjectStatusBadge = ({ value = "--" }) => (
  <Badge className="fixed-width" color={getProjectStatusColor(value)}>
    {value}
  </Badge>
);

ProjectStatusBadge.propTypes = {
  value: PropTypes.string
};

export default ProjectStatusBadge;
